import React from 'react';

import { Button, Flex } from 'antd';
import { toast } from 'react-toastify';
import IconAsText from 'src/components/IconAsText';
import { DownloadOutlined } from '@ant-design/icons';
import type { ModuleView } from 'src/interfaces/entities/module';

import {
	ModuleAdditionalInfoContainer,
	ModuleInfoContainer,
	ModuleDescription,
	ModuleSubtitle,
	ModuleTitle
} from 'src/pages/store/components/ModuleInfo/styles';
import {
	useCloneModuleMutation
} from 'src/redux/services/centralApi';

export default function ModuleInfo(
	{
		module,
		selectedObservers,
		hasSelectedObservers,
	}: {
		module: ModuleView
		selectedObservers: Array<string>
		hasSelectedObservers: boolean
	}
) {
	const [ cloneModule, cloneStatus, ] = useCloneModuleMutation();

	return (
		<ModuleInfoContainer>
			<Flex gap={8} style={{ color: '#001529', }}>
				<IconAsText
					//@ts-ignore
					icon={module.icon ?? 'borderOutlined'}
					fontSize={30}
				/>
				<Flex vertical>
					<ModuleTitle>
						{module.name}
					</ModuleTitle>
					<ModuleSubtitle>
						{module.team} - {module.target}
					</ModuleSubtitle>
				</Flex>
			</Flex>
			<ModuleDescription>
				{module.long_description}
			</ModuleDescription>
			{
				(module.metadata && Object.keys(module.metadata).length > 0)
                && <ModuleAdditionalInfoContainer>
                	<strong>Dados adicionais:</strong>
                	<Flex vertical gap={8}>
                		{Object.entries(module.metadata).map(([ key, value, ], i) => (
                			<span style={{ marginLeft: '8px', }} key={i}>
                				<strong>{`${key}: `}</strong>{value}
                			</span>
                		))}
                	</Flex>
                </ModuleAdditionalInfoContainer>
			}
			<Flex justify='end'>
				<Button
					onClick={() => {
						cloneModule({ id: module.module_id, observers: selectedObservers, })
							.unwrap()
							.then(() => {
								toast.success(`Módulo: ${module.name} clonado com sucesso`);
							})
							.catch((err) => {
								console.error(err);
								toast.error(`Erro ao clonar módulo: ${module.name}`);
							});
					}}
					loading={cloneStatus.isLoading}
					disabled={!hasSelectedObservers}
					icon={<DownloadOutlined />}
					type='primary'
				>
                    Importar selecionados
				</Button>
			</Flex>
		</ModuleInfoContainer>
	);
}
